import { render, staticRenderFns } from "./owner-select.vue?vue&type=template&id=1a7536b9&"
import script from "./owner-select.vue?vue&type=script&lang=js&"
export * from "./owner-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "owner-select.vue"
export default component.exports